var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -30 512 511",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m76 .5c-24.902344 0-45 20.097656-45 45s20.097656 45 45 45 45-20.097656 45-45-20.097656-45-45-45zm0 0",
    fill: "#00c0f1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m76 90.5c-41.398438 0-76 33.601562-76 75v45h151v-45c0-41.398438-33.601562-75-75-75zm0 0",
    fill: "#25d9f8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00c0f1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m76 90.5v-90c24.902344 0 45 20.097656 45 45s-20.097656 45-45 45zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151 165.5v45h-75v-120c41.398438 0 75 33.601562 75 75zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m436 .5c-24.902344 0-45 20.097656-45 45s20.097656 45 45 45 45-20.097656 45-45-20.097656-45-45-45zm0 0"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m436 90.5c-41.398438 0-75 33.601562-75 75v45h151v-45c0-41.398438-34.601562-75-76-75zm0 0",
    fill: "#25d9f8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m436 90.5v-90c24.902344 0 45 20.097656 45 45s-20.097656 45-45 45zm0 0",
    fill: "#00c0f1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m512 165.5v45h-76v-120c41.398438 0 76 33.601562 76 75zm0 0",
    fill: "#00c0f1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m330.128906 311.054688 42.421875-42.421876 139.441407 139.445313-42.421876 42.421875zm0 0",
    fill: "#009ae4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m255.996094 30.621094c-91.234375 0-164.875 73.644531-164.875 164.878906s73.640625 164.878906 164.875 164.878906 164.878906-73.644531 164.878906-164.878906-73.644531-164.878906-164.878906-164.878906zm0 0",
    fill: "#537983"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m421 195.5c0 90.898438-74.097656 165-165 165v-330c90.902344 0 165 74.097656 165 165zm0 0",
    fill: "#3e5959"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m256.003906 60.59375c-74.652344 0-134.910156 60.253906-134.910156 134.90625s60.257812 134.90625 134.910156 134.90625c74.648438 0 134.90625-60.253906 134.90625-134.90625s-60.257812-134.90625-134.90625-134.90625zm0 0",
    fill: "#e0f4ff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m391 195.5c0 74.398438-60.601562 135-135 135v-270c74.398438 0 135 60.597656 135 135zm0 0",
    fill: "#bbdcff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m256 90.5c-24.902344 0-45 20.097656-45 45s20.097656 45 45 45 45-20.097656 45-45-20.097656-45-45-45zm0 0",
    fill: "#00c0f1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m256 180.5c-41.398438 0-75 33.601562-75 75v45h150v-45c0-41.398438-33.601562-75-75-75zm0 0",
    fill: "#25d9f8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m256 180.5v-90c24.902344 0 45 20.097656 45 45s-20.097656 45-45 45zm0 0",
    fill: "#00c0f1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m331 255.5v45h-75v-120c41.398438 0 75 33.601562 75 75zm0 0",
    fill: "#00c0f1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.37724961f93ee0c837237a19fe0c9bde.svg";
export { ForwardRef as ReactComponent };